import { Box, Typography, Stack } from "@mui/material";
import { observer } from "mobx-react-lite";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import Language from "e.sic-platform.webclient/src/services/translation/language";

export default observer(function HomeHero() {
    // Both languages should wrap to exactly 5 lines, so the maxWidth has to track the
    // active language (the German text is ~30% longer than the English one).
    // Measured wrap bands for the current copy (Segoe UI 16px, body1 letter-spacing):
    //   German  -> 5 lines between 955px and 1120px  (1020px sits mid-band)
    //   English -> 5 lines between 685px and 875px   (780px sits mid-band)
    // Re-measure these if the hero copy changes.
    const descriptionMaxWidth =
        translationService.language === Language.german
            ? "min(92vw, 1020px)"
            : "min(92vw, 780px)";
    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: "100%",
                boxSizing: "border-box",
                overflow: "hidden",
                mt: -3,
                pt: 7,
                pb: 3,
                px: 4,
                mb: 2,
                backgroundImage: "url('/images/top.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundColor: "#0a2a4a",
                // minHeight (not a fixed height) so a narrower/taller text column grows the
                // hero instead of being clipped by overflow: hidden.
                minHeight: 280,
                color: "common.white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
            }}
        >
            <Stack spacing={1.5} alignItems="center" sx={{ width: "100%" }}>
                <Typography variant="h3" sx={{ fontWeight: 600, lineHeight: 1.2, m: 0, maxWidth: 900 }}>
                    {translationService.translate("general.smartApps.title")}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        opacity: 0.9,
                        lineHeight: 1.6,
                        // Dynamic width: wraps to 5 lines on typical desktop screens, and
                        // falls back to the viewport width on narrower ones.
                        maxWidth: descriptionMaxWidth,
                        mx: "auto",
                    }}
                >
                    {translationService.translate("general.smartApps.description")}
                </Typography>
            </Stack>
        </Box>
    );
});
